export default __webpack_public_path__ + "static/bottomBanner-88b77d1634996b59d8d2c014f5496801.png";